import React from "react";
import Validation from "../validation/validation";
import "./textField.css";

export default class TextField extends React.Component {
  state = {
    text: "",
  };


  changeValue = (value) => {
    let aux = Validation(this.props.validationType,value.target.value);
    this.setState({ text: aux });

    this.props.parentCallback({
      value: aux,
    })

    
    this.props.parentCallback(aux,value.target.name);

  };

  handleKeys = (e, id,decimal) => {
    if (document.getElementById(`${id}`)) {

      if(decimal){
        if((e.which != 8 && e.which != 46  && e.which != 0 && e.which < 48) || e.which > 57) {
          e.onpaste = () => { return false };
          e.preventDefault();
        }
      }else{
        if ((e.which != 8  && e.which != 0 && e.which < 48) || e.which > 57) {
          e.onpaste = () => { return false };
          e.preventDefault();
        }
      }
    }
  }

  render() {
    return (
      <div className="Entrada">
          {!this.props.noLabel ? <label>
              <strong>{this.props.title}:</strong>{" "}
            </label> : null}
          <div>
            {this.props.section ? (
              <input
                onFocus={this.resizeComponent}
                autoFocus={this.props.focus}
                className={"input"}
                id={this.props.id}
                step={"0"}
                name={this.props.name}
                minLength={this.props.min}
                maxLength={this.props.max}
                pattern={this.props.pattern}
                placeholder={this.props.placeholder}
                value={this.props.value}
                readOnly={(this.props.readOnly === true) ? (true) : (false)}
                type={this.props.typeValue}
                onChange={this.changeValue}
                onKeyPress={(e) => this.handleKeys(e, this.props.id,this.props.decimal)}
              />
            ) : (
              <input
                autoFocus={this.props.focus}
                className={"input"}
                name={this.props.name}
                minLength={this.props.min}
                maxLength={this.props.max}
                pattern={this.props.pattern}
                placeholder={this.props.placeholder}
                value={this.props.value}
                readOnly={(this.props.readOnly === true) ? (true) : (false)}
                type={this.props.typeValue}
                onChange={this.changeValue}
              />
            )}
          </div>
      </div>
    );
  }
}